/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLiveBiddingMetrics } from '../fn/metrics/get-live-bidding-metrics';
import { GetLiveBiddingMetrics$Params } from '../fn/metrics/get-live-bidding-metrics';
import { getLotMetrics } from '../fn/metrics/get-lot-metrics';
import { GetLotMetrics$Params } from '../fn/metrics/get-lot-metrics';
import { LiveBiddingMetricsDto } from '../models/live-bidding-metrics-dto';
import { LotMetricsDto } from '../models/lot-metrics-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedMetricsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLiveBiddingMetrics()` */
  static readonly GetLiveBiddingMetricsPath = '/api/metrics/live-bidding';

  /**
   * Retrieves live-bidding metrics for a given time range.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLiveBiddingMetrics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveBiddingMetrics$Response(params?: GetLiveBiddingMetrics$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveBiddingMetricsDto>> {
    return getLiveBiddingMetrics(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves live-bidding metrics for a given time range.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLiveBiddingMetrics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveBiddingMetrics(params?: GetLiveBiddingMetrics$Params, context?: HttpContext): Observable<LiveBiddingMetricsDto> {
    return this.getLiveBiddingMetrics$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveBiddingMetricsDto>): LiveBiddingMetricsDto => r.body)
    );
  }

  /** Path part for operation `getLotMetrics()` */
  static readonly GetLotMetricsPath = '/api/metrics/lots';

  /**
   * Retrieves lot metrics for a given time range.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLotMetrics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLotMetrics$Response(params?: GetLotMetrics$Params, context?: HttpContext): Observable<StrictHttpResponse<LotMetricsDto>> {
    return getLotMetrics(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves lot metrics for a given time range.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLotMetrics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLotMetrics(params?: GetLotMetrics$Params, context?: HttpContext): Observable<LotMetricsDto> {
    return this.getLotMetrics$Response(params, context).pipe(
      map((r: StrictHttpResponse<LotMetricsDto>): LotMetricsDto => r.body)
    );
  }

}
